import { InjectionToken } from '@angular/core';
import { PopoverPlacement, popoverPlacement } from '@sb/ui/popover';

export const EMPLOYEE_POPOVER_DEFAULT_PLACEMENT = PopoverPlacement.LEFT;

export const EMPLOYEE_POPOVER_PLACEMENT = new InjectionToken<popoverPlacement>('EMPLOYEE_POPOVER_PLACEMENT', {
  factory: () => EMPLOYEE_POPOVER_DEFAULT_PLACEMENT,
});
